// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D_5u","importantInfo":"styles_importantInfo__Ogi31"};